module.exports = __webpack_public_path__ + "bbf87f97f40cc4172b5dea65fdceac89.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/dff-icn-clr.png
// module id = 1566
// module chunks = 0